export default "__VITE_ASSET__9479f561__"